<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="!$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">標準原価編集</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0" class="pa-2">
				<p class="text-body-2 mt-4">
					製品名：{{ selectedProduct ? selectedProduct.name : "" }}<br />
					製品番号：{{ selectedProduct ? selectedProduct.product_code : "" }}<br />
				</p>

				<v-form ref="form" v-model="valid">
					<div class="table-box">
						<table v-for="(cost_category, index) in costCategories" :key="index.id" class="mt-1">
							<tr v-if="cost_category.required_plan">
								<td rowspan="2" width="20%" class="category">
									{{ cost_category.name }}
								</td>

								<td rowspan="2" width="20%" class="price">{{ totalPrice(cost_category) }}円</td>
								<span v-for="(cost_item, index) in cost_category.cost_items" :key="cost_item.id">
									<td width="40%" class="item">
										<v-text-field
											class="mt-5 px-2"
											background-color="white"
											:label="`${cost_item.name}`"
											outlined
											dense
											suffix="円"
											type="number"
											:rules="[rules.integer]"
											v-model="cost_item.value"
											@input="reCalculateTotalCategoryCost(cost_category, cost_item)"
										/>
									</td>
									<v-divider v-if="index < cost_category.cost_items.length - 1"></v-divider>
								</span>
							</tr>
						</table>
					</div>
				</v-form>
			</v-sheet>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col sm="4" cols="0" />
					<v-col sm="4" cols="12">
						<v-row no-gutters justify="center">
							<v-btn color="secondary" @click="submitForm" :disabled="!valid">
								<v-icon class="mr-2">mdi-pencil</v-icon>
								編集する
							</v-btn>
						</v-row>
					</v-col>
					<v-col sm="4" cols="0" v-if="!$vuetify.breakpoint.xs">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="showDialog = false"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import rules from "../../../helper/rules"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		selectedProduct: {
			type: null,
			required: false,
		},
		costCategories: {
			type: Array,
			required: false,
		},
	},
	data() {
		return {
			authority_flag: false,
			product: {
				design_cost: null,
				component_cost: null,
				material_cost: null,
				paint_cost: null,
				labour_cost: null,
				delivery_cost: null,
				miscellaneous_expense: null,
			},
			valid: false,
			rules,
		}
	},

	methods: {
		fetchStandardCosts(selectedProduct) {
			this.selectedProduct = selectedProduct
			this.selectedProduct.standard_cost_item_prices.forEach((item_price) => {
				this.costCategories.forEach((category) => {
					category.cost_items.forEach((cost_item) => {
						if (item_price.cost_item.id == cost_item.id) {
							this.$set(cost_item, "value", item_price.price)
						}
					})
				})
			})
		},
		totalPrice(cost_category) {
			const total = cost_category.cost_items.reduce((sum, cost_item) => sum + cost_item.value, 0)
			this.$set(cost_category, "value", total)
			return Number(total).toLocaleString()
		},
		reCalculateTotalCategoryCost(cost_category, cost_item) {
			cost_item.value = Number(cost_item.value)
			cost_category.value = cost_category.cost_items.reduce((sum, item) => sum + item.value, 0)
		},

		submitForm() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/products/standard_costs/${this.selectedProduct.id}`

			const formData = new FormData()

			this.costCategories.forEach((cost_category) => {
				cost_category.cost_items.forEach((cost_item) => {
					formData.append(`product[cost_item_prices][${cost_item.id}][price]`, cost_item.value)
				})
			})
			axios
				.put(url, formData, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "標準原価を編集しました",
					})
					this.$emit("reload-index")
					this.showDialog = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		selectedProduct(newVal, oldVal) {
			this.fetchStandardCosts(newVal)
		},
		deep: true,
	},
}
</script>
<style scoped lang="scss">
@import "../../../stylesheet/variable.scss";

table {
	border-collapse: collapse;
	text-align: center;
	width: 100%;
}
th,
td {
	border: 1px solid black;
}
.category {
	background-color: whitesmoke;
}

.item {
	background-color: whitesmoke;
}

.price {
	border-right: none;
}
</style>
